// extracted by mini-css-extract-plugin
export var link = "FancyLink-module--link--3d5f9";